import type { UIKitPalette } from '../types';

const Palette: UIKitPalette = {
  primary100: '#DBD1FF',
  primary200: '#C2A9FA',
  primary300: '#742DDD',
  primary400: '#6211C8',
  primary500: '#491389',

  secondary100: '#A8E2AB',
  secondary200: '#69C085',
  secondary300: '#259C72',
  secondary400: '#027D69',
  secondary500: '#066858',

  error100: '#FDAAAA',
  error200: '#F66161',
  error300: '#DE360B',
  error400: '#BF0711',
  error500: '#9D091E',

  background50: '#FFFFFF',
  background100: '#EEEEEE',
  background200: '#E0E0E0',
  background300: '#BDBDBD',
  background400: '#393939',
  background500: '#2C2C2C',
  background600: '#161616',
  background700: '#000000',

  overlay01: 'rgba(0,0,0,0.55)',
  overlay02: 'rgba(0,0,0,0.32)',

  information: '#ADC9FF',
  highlight: '#FFF2B6',
  transparent: 'transparent',

  onBackgroundLight01: 'rgba(0,0,0,0.88)',
  onBackgroundLight02: 'rgba(0,0,0,0.50)',
  onBackgroundLight03: 'rgba(0,0,0,0.38)',
  onBackgroundLight04: 'rgba(0,0,0,0.12)',

  onBackgroundDark01: 'rgba(255,255,255,0.88)',
  onBackgroundDark02: 'rgba(255,255,255,0.50)',
  onBackgroundDark03: 'rgba(255,255,255,0.38)',
  onBackgroundDark04: 'rgba(255,255,255,0.12)',
};

export default Palette;
